/**
 * Tutorial step tracking utilities
 */

// Tutorial step tracking
export function setCurrentTutorialStep(step: number) {
  window.dispatchEvent(new CustomEvent('tutorialStepChanged', { detail: { step } }))
}

// Utility function for cleaning up driver elements
export function cleanupDriverElements() {
  const driverElements = document.querySelectorAll(
    '.driver-popover, .driver-overlay, .driver-highlighted-element, .driver-no-interaction, .driver-fade-element, [data-driver-popover], [data-driver-overlay], .driver-stage',
  )
  driverElements.forEach(element => element.remove())

  document.body.classList.remove('driver-active', 'driver-fade')
  document.documentElement.classList.remove('driver-active', 'driver-fade')
}
